import React from 'react'
import PropTypes from 'prop-types'
import { ANALOG_INPUT } from 'utils/constants'

import {
  InputOperatorEditor,
  InputValueEditor,
  HysteresisEditor,
  InputConfigEditor,
  EdgeEditor,
  InputCustomDescription,
} from './base'

const AnalogInputEditor = ({
  uri,
  isLogicSet,
  isNonBoolNativeOutput,
  isSixteenBitCanOutput,
  signal,
  floatingCircuit,
  inputConfig,
  disableFalseValue,
  fnId,
  customDescription,
  inputUri,
}) => {
  const showOperatorAndValueEditor = !isSixteenBitCanOutput
  return (
    <>
      <InputCustomDescription
        uri={uri}
        inputUri={inputUri || signal}
        customDescription={customDescription}
        subType={ANALOG_INPUT}
      />
      {showOperatorAndValueEditor && (
        <InputOperatorEditor flexShrink={0} uri={uri} fnId={fnId} />
      )}

      {isLogicSet && <HysteresisEditor uri={uri} />}

      <InputConfigEditor
        uri={uri}
        signalUri={signal}
        floatingCircuit={floatingCircuit}
        fixedDataType={ANALOG_INPUT}
        inputConfig={inputConfig}
      />

      {showOperatorAndValueEditor && (
        <InputValueEditor
          uri={uri}
          disableFalseValue={disableFalseValue}
          disabled={isNonBoolNativeOutput}
        />
      )}

      {isLogicSet && <EdgeEditor uri={uri} />}
    </>
  )
}

AnalogInputEditor.propTypes = {
  uri: PropTypes.string,
  isLogicSet: PropTypes.bool,
  isNonBoolNativeOutput: PropTypes.bool,
  isSixteenBitCanOutput: PropTypes.bool,
  signal: PropTypes.string,
  floatingCircuit: PropTypes.string,
  inputConfig: PropTypes.string,
  showOperators: PropTypes.bool,
  disableFalseValue: PropTypes.bool,
  fnId: PropTypes.string,
  customDescription: PropTypes.string,
  inputUri: PropTypes.string,
}

export default AnalogInputEditor
